module.exports = __webpack_public_path__ + "media/components/page-header/static/weather-badge--dark-1e6f32e2472d02eea778b09b6e878689.svg";